module.exports = __webpack_public_path__ + "img/video-head.71aba21e.png";